"use client";
import Link from "next/link";
import React, { useEffect, useState } from "react";

export default function Page() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch("/api/web-content");
        if (response.ok) {
          const data = await response.json();
          if (data?.dressCode) {
            setContent(data.dressCode);
            document.title = `${data.dressCode.title || "Dress Code Policy"} || Arena Water Park`;
          }
        }
      } catch (error) {
        console.error("Failed to fetch Dress Code Policy:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh", width: "100%" }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{
            color: "var(--theme-color, #F55B1F)",
            width: "3rem",
            height: "3rem",
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: 'url("/assets/img/banners/dresscode_bg_new.webp")',
        }}
      >
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  {content?.title || "Dress Code Policy"}
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>{content?.title || "Dress Code Policy"}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section
        id="about"
        className="about-section fix section-padding scrollSpySection"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="row">
              <div className="col-lg-12">
                {content?.content ? (
                  <div
                    className="wysiwyg-content"
                    dangerouslySetInnerHTML={{ __html: content.content }}
                  />
                ) : (
                  <p>No content available yet.</p>
                )}
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-12 text-center  justify-content-center align-items-center d-flex">
                <img 
                  src="/assets/img/dresscodebanner.jpeg" 
                  alt="Dress Code" 
                  className="img-fluid rounded-4 shadow-lg wow zoomIn"
                  data-wow-delay=".3s"
                  style={{ maxWidth: '400px', height: 'auto', border: '5px solid #fff' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
